import {
  // CourseList,
  // CourseDetail,
  CoursePackList,
  // CoursePackDetail,
  CouseSelectList,
  // CourseVideo,
  // Coupon,
} from './';
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
import loadable from "../../utils/loadable"
const LoadCourseList = loadable(() => import('../course/CourseList'));
const LoadCourseDetail = loadable(() => import('../course/CourseDetail'));
const LoadCoursePackDetail = loadable(() => import('../course/CoursePackDetail'));
const LoadCourseVideo = loadable(() => import('../course/CourseVideo'));
const LoadCoupon = loadable(() => import('../course/Coupon'));
export default {
  path: 'course',
  name: 'Course',
  childRoutes: [
    { path: '/courseList/:id', name: 'Course list', component: LoadCourseList },
    { path: '/course/detail/:id', name: 'Course detail', component: LoadCourseDetail },
    { path: '/coursepacklist/:id', name: 'Course pack list', component: CoursePackList },
    { path: '/coursepack/detail/:id', name: 'Course pack detail', component: LoadCoursePackDetail },
    { path: '/select/:id/:id', name: 'Couse select list', component: CouseSelectList },
    { path: '/course/video/:id', name: 'Course video', component: LoadCourseVideo },
    { path: '/course/coupon', name: 'Coupon', component: LoadCoupon },
  ],
};



// WEBPACK FOOTER //
// ./src/features/course/route.js